import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { createTaskTrigger, fetchTree } from '../../../apis';
import { generateForm } from '../../form/Form';

var dataSources = function dataSources(_ref) {
  var sourceName = _ref.sourceName,
      sourceGroup = _ref.sourceGroup,
      name = _ref.name,
      workflowType = _ref.workflowType;
  return {
    nodes: {
      fn: fetchTree,
      params: name && [{
        type: workflowType || 'Tree',
        sourceName: sourceName,
        sourceGroup: sourceGroup,
        name: name,
        include: 'treeJson'
      }],
      transform: function transform(result) {
        return result.tree && result.tree.treeJson ? result.tree.treeJson.nodes.map(function (node) {
          return {
            label: "".concat(node.name, " (").concat(node.id, ")"),
            value: node.id
          };
        }) : [];
      }
    }
  };
};

var handleSubmit = function handleSubmit(formOptions) {
  return function (values) {
    return createTaskTrigger(_objectSpread(_objectSpread({}, formOptions), values.toJS())).then(function (_ref2) {
      var error = _ref2.error,
          message = _ref2.message,
          messageType = _ref2.messageType;

      if (error) {
        throw error.message || 'An error occurred while manually creating the trigger.';
      }

      if (messageType === 'success') {
        return message;
      }
    });
  };
};

var fields = function fields(_ref3) {
  var name = _ref3.name;
  return function () {
    return name && [{
      name: 'nodeId',
      label: 'Node Id',
      type: 'select',
      required: true,
      options: function options(_ref4) {
        var nodes = _ref4.nodes;
        return nodes;
      },
      helpText: 'The node in the workflow you want to create a trigger for.'
    }, {
      name: 'loopIndex',
      label: 'Loop Index',
      type: 'text',
      required: false,
      helpText: 'Required when executing a node defined within a loop (ex. /3#0)',
      placeholder: 'Required when executing a node defined within a loop (ex. /3#0)'
    }, {
      name: 'branchId',
      label: 'Branch Id',
      type: 'text',
      required: false,
      helpText: 'Required when executing a node defined after an update connect (ex. 11023)',
      placeholder: 'Required when executing a node defined after an update connect (ex. 11023)',
      pattern: /^\d*$/,
      patternMessage: 'Branch ID must be a number',
      serialize: function serialize(_ref5) {
        var values = _ref5.values;
        return parseInt(values.get('branchId'));
      }
    }];
  };
};

export var CreateManualTriggerForm = generateForm({
  formOptions: ['sourceName', 'sourceGroup', 'name', 'workflowType', 'runId'],
  dataSources: dataSources,
  fields: fields,
  handleSubmit: handleSubmit
});
CreateManualTriggerForm.displayName = 'CreateManualTriggerForm';